import enGB from 'dayjs/locale/en-gb';

import { getLanguage } from '@cognite/cdf-i18n-utils';

export const getInitialLocale = () => {
  const savedLanguage = getLanguage();
  const languageCode = savedLanguage || 'en';

  // Handle English locale variations (same logic as useInfieldLanguage)
  if (languageCode === 'en') {
    const isUsingUSFormat = navigator.language === 'en-US';
    return isUsingUSFormat ? 'en' : enGB;
  }
  return languageCode;
};
